export var setSportId = function (sportIds, item) {
    return sportIds.indexOf(item.sportId) !== -1
        ? item.sportId
        : "0";
};
//# sourceMappingURL=setSportId.js.map